import { type IPagination } from './types';

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SEARCH_KEY = '_default_';
export const DEFAULT_PAGINATION: IPagination = {
    currentPage: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    rowsNumber: 0,
    orderBy: []
};
